import { Stack } from '@src/shared/ui/layout';
import { PAGE_LAYOUT_SCROLL_CONTAINER_ID } from './constants';
import type { ReactNode } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

type LayoutProps = {
  children: ReactNode;
  fillHeight?: boolean;
};

export default function Layout({ children, fillHeight = false }: LayoutProps) {
  return (
    <Stack
      id={PAGE_LAYOUT_SCROLL_CONTAINER_ID}
      useFlexGap
      spacing={1}
      sx={{ overflowY: 'auto' }}
    >
      <Header />
      <Stack
        direction="row"
        useFlexGap
        spacing={1.25}
        sx={fillHeight ? { height: '100%' } : undefined}
      >
        {children}
        <Sidebar />
      </Stack>
    </Stack>
  );
}
